/**
 * Acceso denegado — no redirigir al Dashboard (falso éxito).
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaLock, FaArrowLeft } from 'react-icons/fa';

export default function AccessDenied({
  title = 'Acceso denegado',
  message = 'No tenés permiso para ver esta sección.',
  detail = null,
  backTo = '/',
  backLabel = 'Volver al inicio'
}) {
  const location = useLocation();
  const reason = location.state?.reason || location.state?.moduleBlocked || null;

  return (
    <div className="mx-auto flex min-h-[50vh] max-w-lg flex-col items-center justify-center px-4 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-500/40 bg-amber-500/15 text-amber-200">
        <FaLock size={22} aria-hidden />
      </div>
      <h1 className="text-xl font-semibold text-e0e3-foreground">{title}</h1>
      <p className="mt-2 text-sm text-e0e3-muted">{message}</p>
      {(detail || reason) && (
        <p className="mt-2 text-xs text-e0e3-muted/80">
          {detail || (reason === 'forbidden'
            ? 'Tu usuario no tiene el permiso requerido.'
            : reason
              ? `Módulo no disponible en el plan actual: ${reason}.`
              : null)}
        </p>
      )}
      <Link
        to={backTo}
        className="mt-6 inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.06] px-4 py-2 text-sm font-medium text-e0e3-foreground transition hover:bg-white/[0.1]"
      >
        <FaArrowLeft size={12} aria-hidden />
        {backLabel}
      </Link>
    </div>
  );
}
